// eslint-disable-next-line import/prefer-default-export
export const BANK_ACCOUNT_TYPES = [
  {
    label: 'Bank Account',
    value: 1,
  },
  {
    label: 'Credit Card',
    value: 2,
  },
  {
    label: 'Debit Card',
    value: 3,
  },
];
